module.exports = __webpack_public_path__ + "static/amc_logo-b034dbbc971a7ec678c12958421cb638.png";